import { Icon } from "@iconify/react";
import { Tooltip } from "antd";
import { onRemove } from "../helper/method";

export default function MediaPreview({
  mediaUrl,
  id,
  type,
  setFile,
}: {
  mediaUrl: string;
  id: string;
  type: "video" | "image";
  setFile: React.Dispatch<
    React.SetStateAction<
      {
        file: File | undefined;
        fileUrl: string;
        id: string;
      }[]
    >
  >;
}) {
  return (
    <Tooltip title={id} placement={"bottom"}>
      <div className="col-span-1 relative overflow-hidden aspect-square rounded-2xl">
        <button
          type="button"
          onClick={() => onRemove(id, setFile)}
          className="absolute top-1 left-1 text-4xl! cursor-pointer"
        >
          <Icon
            icon={"ic:baseline-cancel"}
            className="w-8 h-8 text-error-500"
          />
        </button>
        {type === "image" ? (
          <img
            src={mediaUrl}
            alt="pre-view"
            className="w-full h-full object-cover"
          />
        ) : (
          <video
            controls
            src={mediaUrl}
            className="w-full h-full object-cover"
          />
        )}
      </div>
    </Tooltip>
  );
}
